import {postRequest} from "./helper"

export const SubUserAddApi = (data) => postRequest('add-subuser',data);
export const SubUserListApi = (data) => postRequest('subuser-list',data);
export const SubUserStatusApi = (data) => postRequest('subuser-change-status',data);



// WEBPACK FOOTER //
// ./src/api/Subuser.js